import { combineReducers } from 'redux';
import homeReducer from './home/home.reducer';
import authReducer from './auth/auth.reducer';

export const rootReducer = combineReducers({
  home: homeReducer,
  auth: authReducer,
});
